/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/styles';
import { array, object } from 'prop-types';
import { Grid } from '@material-ui/core';
import BGSCmsStyles from './BGSCmsStyles';
import BGSReviews from './BGSReviews';

const BGSCms = ({
    classes, articles, header, slider, hero,
}) => {
    const renderArticles = articles?.map((article) => (
        <Grid key={article?._metadata?.uid} item sm={4} className="text-center processBlock">
            <div className="processBlockInnerWrapper">
                <div className="imageContainer">
                    <img className="image" src={article.image.url} alt="" />
                </div>
                <h2 className="subheading">{article.heading}</h2>
                <p className="textBlock">{article.copy}</p>
            </div>
        </Grid>
    ));

    return (
        <div className={`${classes.bgsCMSWrapper}`}>
            <div>
                <article className="row bgsBannerWrapper">
                    <div id="bannerLink" className="text-center bgsBannerPadding background" style={{ background: 'unset' }}>
                        <figure className="aside-img desktopBanner">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2518 784" preserveAspectRatio="xMinYMin meet">
                                <image href={hero?.image?.url} />
                                <g opacity="0">
                                    <a href="https://assets.contentstack.io/v3/assets/blt4454dc0093319d35/blt7ec8cd629c61a995/6466386b2bb6137b2664599b/gifting-catalogue.pdf" target="_blank" rel="noreferrer">
                                        <rect x="1664" y="414" width="505" height="90" />
                                    </a>
                                </g>
                                <g opacity="0">
                                    <a href="/c/corporate-gifts" target="_blank" rel="noreferrer">
                                        <rect x="1664" y="540" width="505" height="90" />
                                    </a>
                                </g>
                            </svg>
                        </figure>
                        <figure className="aside-img mobileBanner">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 828 1434" preserveAspectRatio="xMinYMin meet">
                                <image href={hero?.mobile_image?.url} />
                                <g opacity="0">
                                    <a href="https://assets.contentstack.io/v3/assets/blt4454dc0093319d35/blt7ec8cd629c61a995/6466386b2bb6137b2664599b/gifting-catalogue.pdf" target="_blank" rel="noreferrer">
                                        <rect x="156" y="458" width="518" height="88" />
                                    </a>
                                </g>
                                <g opacity="0">
                                    <a href="/c/corporate-gifts" target="_blank" rel="noreferrer">
                                        <rect x="156" y="573" width="518" height="88" />
                                    </a>
                                </g>
                            </svg>
                        </figure>
                    </div>
                </article>
                <article className="row bgsAboutWrapper">
                    <Grid item md={12} className="text-center">
                        <h2 className="text-uppercase font-family-bebas">{header.copy}</h2>
                    </Grid>
                </article>
                <Grid container className="bgsProcessWrapper" justifyContent="center">
                    {renderArticles}
                </Grid>
                <article className="reviewsSection">
                    <Grid item sm={12} className="reviewsTitle">
                        <h2 className="title">What Our Customers Are Saying</h2>
                    </Grid>
                    <BGSReviews slider={slider} />
                </article>
            </div>
        </div>
    );
};

BGSCms.propTypes = {
    classes: object.isRequired,
    articles: array.isRequired,
    header: object.isRequired,
    slider: array.isRequired,
    hero: object,
};

BGSCms.defaultProps = {
    hero: {},
};

export default withStyles(BGSCmsStyles)(BGSCms);
